"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("rect", {
    y: "12.69",
    width: "4",
    height: "9",
    rx: "0.5",
    ry: "0.5",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M23.85,16.83a3.24,3.24,0,0,0-3.51-1.12l-3,1a2.42,2.42,0,0,1-2.33,3H10a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h5a1.37,1.37,0,0,0,1.38-1.5A1.38,1.38,0,0,0,15,15.69H12a.47.47,0,0,1-.35-.15A5.8,5.8,0,0,0,7.5,13.69h-2a.5.5,0,0,0-.5.5v5.5a.51.51,0,0,0,.34.47c1.56.52,3.28,1,4.26,1.32a12.94,12.94,0,0,0,4,1.08c1.95,0,3.39-1.54,10.15-4.92A.51.51,0,0,0,23.85,16.83Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M5.43,14.8a.17.17,0,0,1-.16-.17v-.69a.16.16,0,0,1,.16-.16h.93a.17.17,0,0,0,.17-.17v-.37a.18.18,0,0,1,.17-.17H8.37a.18.18,0,0,1,.17.17v.43a.16.16,0,0,0,.17.16h2.41a.17.17,0,0,0,.17-.16v-.41a.18.18,0,0,1,.17-.17H21.89a.17.17,0,0,1,.16.17v.46a.17.17,0,0,1-.16.17s-3.77,0-5.31.26a5.41,5.41,0,0,0-2,.56.62.62,0,0,1-.3.09Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M15.15,12.21a.18.18,0,0,0,.17.17h3.79a.18.18,0,0,0,.17-.17V8.82a.27.27,0,0,0-.15-.23L19,8.52a12.37,12.37,0,0,1-3.74-3.28c-.05-.08-.1-.06-.1,0v6.94Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20,9a.12.12,0,0,0-.16.12v3.14a.17.17,0,0,0,.16.17h1.52a1.55,1.55,0,0,0,.31,0l.07,0,.08-.06V9.73a.19.19,0,0,0-.17-.18L20,9Z",
    fill: "#024965"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.29,5.14A.12.12,0,0,1,6.17,5L7,2.47a.25.25,0,0,1,.22-.16H12.7a.21.21,0,0,1,.2.16L13.38,5a.15.15,0,0,1-.14.17ZM12.06,9.4a.66.66,0,0,1-.66-.65.67.67,0,0,1,.66-.66.66.66,0,0,1,.65.66.65.65,0,0,1-.65.65Zm-5.17,0a.65.65,0,0,1-.65-.65.66.66,0,0,1,.65-.66.67.67,0,0,1,.66.66.66.66,0,0,1-.66.65Zm7.67-5.1A.87.87,0,0,0,14.5,4a13.15,13.15,0,0,0-1-2,1.42,1.42,0,0,0-.93-.54H7.12c-.18,0-.3.18-.45.39s-1,2.9-1.1,3.26-.19,1-.19,1,0,.24,0,.33L5.27,9.52v.93c0,.27,0,.33.49,1.18s1,.77,1,.77l.33,0H14.4a.17.17,0,0,0,.16-.17V4.3Z",
    fill: "#024965"
  }));
};

exports["default"] = _default;